import AmbulancePage from "../../pages/Dashboard/Ambulance/AmbulancePage";

const ambulanceRoutes = {
  path: "/ambulance",
  element: <AmbulancePage />,
};

export default ambulanceRoutes;
